let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4LYSa")).then(() => parcelRequire('50nRh'));